import React from 'react'
import { AddWorkerCredentialFlowProvider } from './context/AddWorkerCredentialFlowProvider'
import { AddWorkerCredentialFlowMain } from './components/AddWorkerCredentialFlowMain'

type AddWorkerCredentialFlowProps = {
  userId: number
  onSuccess?: () => void
}

export const AddWorkerCredentialFlow = ({
  userId,
  onSuccess,
}: AddWorkerCredentialFlowProps) => {
  return (
    <AddWorkerCredentialFlowProvider>
      <AddWorkerCredentialFlowMain userId={userId} onSuccess={onSuccess} />
    </AddWorkerCredentialFlowProvider>
  )
}
